import {Component} from 'react';
import Glob from "./libs/Glob.mjs";
import appLib from "./libs/appLib.mjs";
import "./media/css/App.css";
import TopBar from "./Components/BaseLayout/TopBar/TopBar.mjs";
import AppMainBackground from "./Components/BaseLayout/AppMainBackground.mjs";
import appPageRouter from "./libs/appPageRouter.mjs";
import SideBar from "./Components/NavigationMenu/SideBar.mjs";

const prefix = 'App';

const modifiersSentinel = e => {
	if ( ! e?.getModifierState ) return;
	const modifiers = [];
	if ( e.getModifierState("Meta") ) modifiers.push("Meta");
	if ( e.getModifierState("Alt") ) modifiers.push("Alt");
	if ( e.getModifierState("Shift") ) modifiers.push("Shift");
	Glob.setStatus("ModifiersPressed", modifiers );
}

const modifiersSentinelSetup = () => {
	if ( window.document.body.classList.contains("modifiersAware")) return;
	window.document.addEventListener("keydown", modifiersSentinel);
	window.document.addEventListener("keyup", modifiersSentinel);
	window.document.body.classList.add("modifiersAware");
}

const App = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			curPage: Glob.getCurrentPage(),
			lang: Glob.getLanguage(),
			slider: true
		};
		this.uid = Glob.generateUid(prefix);
		this.verifyLogin = this.verifyLogin.bind(this);
		this.renderPanel = this.renderPanel.bind(this);
	}
	componentDidMount() {
		Glob.register('currentPage', cp => {
			if ( cp ) this.setState({curPage: cp});
		}, this.uid);
		Glob.register('userLogin', (ul)=>{
			if ( ! ul ) this.setState({ loggingIn: false }, this.verifyLogin );
		}, this.uid);
		Glob.register('Prefs', async (p)=>{
			const cl = p.language;
			if ( cl !== this.state.lang ) this.setState({lang: cl});
		}, this.uid);
		Glob.register('slider', s=>{
			if ( (!!s) !== this.state.slider ) this.setState({slider: !!s});
		}, this.uid);
		setTimeout( modifiersSentinelSetup );
		this.verifyLogin();
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	async verifyLogin() {
		try {
			await appLib.verifySession();
		} catch(err) {
			if ( Glob.getStatus('savedLogin') ) {
				Glob.setStatus('savedLogin', undefined, true);
				window.location.href = Glob.prop.uri.web;
			}
		}
	}
	renderPanel(cp) {
		return appPageRouter(cp);
	}
	render() {
		return (
			<div className={prefix} id={this.uid}>
				<AppMainBackground />
				<TopBar />
				<div className={"AppContent"}>
					<div className={`app-panel-slider slider-${ this.state.slider ? 'on' : 'off' }`}>
						<SideBar />
						<div className={"slider-stage-wrap"}>
							<div className={"slider-stage"} key={this.state.curPage?.name}>
								{this.renderPanel(this.state.curPage)}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default App;